import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth__form" }
const _hoisted_2 = { class: "auth__registration" }
const _hoisted_3 = {
  key: 0,
  type: "submit",
  class: "home-btn auth-btn"
}
const _hoisted_4 = {
  key: 1,
  type: "submit",
  class: "home-btn auth-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendData && _ctx.sendData(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
          type: "text",
          placeholder: "Введите ваш email"
        }, null, 512), [
          [_vModelText, _ctx.formData.email]
        ]),
        (!_ctx.isLogin)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.login) = $event)),
              type: "text",
              placeholder: "Введите ваш логин"
            }, null, 512)), [
              [_vModelText, _ctx.formData.login]
            ])
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event)),
          type: "password",
          placeholder: "Введите ваш пароль"
        }, null, 512), [
          [_vModelText, _ctx.formData.password]
        ])
      ]),
      (!_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("button", _hoisted_3, " Зарегистрироваться "))
        : (_openBlock(), _createElementBlock("button", _hoisted_4, "Войти")),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsList, (err) => {
        return (_openBlock(), _createElementBlock("div", {
          key: err,
          class: "auth__errors"
        }, [
          _createElementVNode("p", null, _toDisplayString(err), 1)
        ]))
      }), 128))
    ], 32)
  ]))
}